/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';

import { MY_ACCOUNT } from 'Component/Header/Header.config';
import {
    ACCOUNT_LOGIN_URL
} from 'Route/MyAccount/MyAccount.config';
import {
    MENU_TAB
} from 'SourceComponent/NavigationTabs/NavigationTabs.config';
import {
    mapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    NavigationTabsContainer as SourceNavigationTabsContainer
} from 'SourceComponent/NavigationTabs/NavigationTabs.container';
import {
    DASHBOARD
} from 'Type/Account.type';
import { isSignedIn } from 'Util/Auth';
import browserHistory from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

export const DEFAULT_NAVIGATION_TABS_STATE = { name: MENU_TAB };

/** @namespace Pwa/Component/NavigationTabs/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    activeOfferId: state.OfferReducer.activeOfferId,
    offerItemsCount: state.OfferReducer.itemsCount
});

/** @namespace Pwa/Component/NavigationTabs/Container */
export class NavigationTabsContainer extends SourceNavigationTabsContainer {
    containerFunctions = {
        onMenuButtonClick: this.onMenuButtonClick.bind(this),
        onMyAccountButtonClick: this.onMyAccountButtonClick.bind(this),
        onMinicartButtonClick: this.onMinicartButtonClick.bind(this),
        onHomeButtonClick: this.onHomeButtonClick.bind(this)
    };

    containerProps() {
        const {
            activeOfferId,
            offerItemsCount
        } = this.props;

        return {
            ...super.containerProps(),
            activeOfferId,
            offerItemsCount
        };
    }

    onMyAccountButtonClick() {
        const { pathname } = location;
        const url = appendWithStoreCode(isSignedIn() ? `/${ MY_ACCOUNT }/${ DASHBOARD }` : ACCOUNT_LOGIN_URL);

        if (pathname !== url) {
            browserHistory.push(url);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationTabsContainer);
